<template>
  <div :class="$style.overlay">
    <form @submit.prevent="handleSubmit">
      <div :class="$style.reservationParent">
        <div :class="$style.reservationPopup" />
        <b :class="$style.reservation">Reservation</b>
        <b :class="$style.dualInstruction">{{ event.eventType.name }}</b>
        <div :class="$style.start0327240730Parent">
          <div :class="$style.start0327240730">Start: {{ eventStart }}</div>
          <div>|</div>
          <div :class="$style.start0327240730">End: {{ eventEnd }}</div>
        </div>
        <div :class="$style.frameParent">
          <div :class="$style.aircraftParent">
            <b :class="$style.aircraft">Aircraft</b>
            <b :class="$style.n2361r">{{ event.aircraft.tailNumber }}</b>
          </div>
          <div :class="$style.hobbsWrapper" v-if="showHobbs">
            <b :class="$style.aircraft">Hobbs</b>
          </div>
          <div :class="$style.hobbsTimeOutParent" v-if="showHobbs">
            <div :class="$style.hobbsTimeOut">Hobbs Time Out</div>
            <div :class="$style.wrapper">
              <input
                v-model="hobbsOut"
                type="number"
                placeholder="Amount..."
                step="any"
                :class="$style.inputStyle"
                required
                @blur="calculateFlightInstructionHours"
              />
            </div>
          </div>
          <div :class="$style.hobbsTimeOutParent" v-if="showHobbs">
            <div :class="$style.hobbsTimeOut">Hobbs Time In</div>
            <div :class="$style.wrapper">
              <input
                v-model="hobbsIn"
                type="number"
                placeholder="Amount..."
                step="any"
                :class="$style.inputStyle"
                required
                @blur="calculateFlightInstructionHours"
                :disabled="!checkInError"
              />
            </div>
          </div>
          <div
            :class="$style.checkInError"
            v-if="showHobbs && event.customer1 && checkInError"
          >
            <i class="fa-solid fa-circle-exclamation"></i>
            Error in card punch data. Please enter the time manually.
          </div>
          <div :class="$style.hobbsWrapper" v-if="showTach">
            <b :class="$style.aircraft">Engine 1Tach</b>
          </div>
          <div :class="$style.hobbsTimeOutParent" v-if="showTach">
            <div :class="$style.hobbsTimeOut">Engine 1Tach Time Out</div>
            <div :class="$style.wrapper">
              <input
                v-model="tachOut"
                type="number"
                placeholder="Amount..."
                step="any"
                :class="$style.inputStyle"
                required
              />
            </div>
          </div>
          <div :class="$style.hobbsTimeOutParent" v-if="showTach">
            <div :class="$style.hobbsTimeOut">Engine 1Tach Time In</div>
            <div :class="$style.wrapper">
              <input
                v-model="tachIn"
                type="number"
                placeholder="Amount..."
                step="any"
                :class="$style.inputStyle"
                required
              />
            </div>
          </div>
          <!--        <div :class="$style.aircraftParent">-->
          <!--          <b :class="$style.aircraft">Aircraft Squawks</b>-->
          <!--          <div :class="$style.addSquawk">+ Add Squawk</div>-->
          <!--        </div>-->
          <!--        <div :class="$style.selectionContainer">-->
          <!--          <div :class="$style.hobbsTimeOut">No Squawks Found</div>-->
          <!--          <div :class="$style.switchContainer">-->
          <!--            <el-switch-->
          <!--              style="display: block"-->
          <!--              v-model="noSquawksFound"-->
          <!--              active-color="#00a551"-->
          <!--              inactive-color="#d54b4e"-->
          <!--            />-->
          <!--          </div>-->
          <!--        </div>-->
          <div :class="$style.instructorWrapper" v-if="showInstructor">
            <b :class="$style.aircraft">Instructor</b>
          </div>
          <div :class="$style.instructorParent" v-if="showInstructor">
            <div :class="$style.aircraft">{{ instructorName }}</div>
            <div :class="$style.aircraft">{{ instructorPhone }}</div>
          </div>
          <div
            :class="$style.hobbsTimeOutParent"
            v-if="showInstructor && showFlightInstructionHours"
          >
            <div :class="$style.hobbsTimeOut">Flight Instruction</div>
            <div :class="$style.wrapper">
              <input
                v-model="flightInstructionHours"
                type="number"
                placeholder="Hours..."
                step="any"
                :class="$style.inputStyle"
                required
              />
            </div>
          </div>
          <div :class="$style.hobbsTimeOutParent" v-if="showInstructor">
            <div :class="$style.hobbsTimeOut">Ground Instruction</div>
            <div :class="$style.wrapper">
              <input
                v-model="groundInstructionHours"
                type="number"
                placeholder="Hours..."
                step="any"
                :class="$style.inputStyle"
                required
              />
            </div>
          </div>
          <!--        <div :class="$style.instructorWrapper">-->
          <!--          <b :class="$style.aircraft">Add Oil & Fuel</b>-->
          <!--        </div>-->
          <!--        <div :class="$style.hobbsTimeOutParent">-->
          <!--          <div :class="$style.hobbsTimeOut">Fuel</div>-->
          <!--          <div :class="$style.wrapper">-->
          <!--            <div :class="$style.aircraft">Units..</div>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        <div :class="$style.hobbsTimeOutParent">-->
          <!--          <div :class="$style.hobbsTimeOut">Engine 1 Oil</div>-->
          <!--          <div :class="$style.wrapper">-->
          <!--            <div :class="$style.aircraft">Units..</div>-->
          <!--          </div>-->
          <!--        </div>-->
        </div>
        <button :class="$style.continueWrapper" type="submit">Continue</button>
        <img
          @click="closeModal"
          :class="$style.vectorIcon"
          alt=""
          src="/static/img/grey-x.svg"
        />
      </div>
    </form>
  </div>
</template>
<script>
import { Switch } from "element-ui";
import ActiveInstructorsAPIService from "@/servicehandlers/ActiveInstructorsAPIService";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
import AircraftAPIService from "@/servicehandlers/AircraftAPIService";
const aircraftAPIService = new AircraftAPIService();
import UsersAPIService from "../../../../servicehandlers/UsersAPIService";
const usersAPIService = new UsersAPIService();
import { defineComponent } from "vue";
import dayjs from "dayjs";
import { formatPhoneNumber } from "@/util/phone";

export default defineComponent({
  components: {
    [Switch.name]: Switch,
  },
  props: {
    event: Object,
  },
  data() {
    return {
      eventStart: "",
      eventEnd: "",
      instructorName: "",
      instructorPhone: "",
      hobbsOut: "",
      hobbsIn: "",
      tachOut: "",
      tachIn: "",
      noSquawksFound: true,
      flightInstructionHours: "",
      groundInstructionHours: "",
      cardSwipes: [],
      checkInError: true,
    };
  },
  async mounted() {
    this.setAndFormatData();
    this.getCardSwipes();
  },
  computed: {
    showHobbs() {
      return ![
        "Checkride Oral",
        "Ground Training",
        "Interview Oral",
        "Potential Student",
      ].includes(this.event?.eventType?.name);
    },
    showTach() {
      return this.showHobbs && this.event?.eventType?.name !== "Frasca Sim";
    },
    showInstructor() {
      if (this.event?.eventType?.name === "Renter/Member Flight") {
        return !!this.event?.instructor;
      }
      return !["Maintenance", "Crew Flight"].includes(
        this.event?.eventType?.name,
      );
    },
    showFlightInstructionHours() {
      return (
        this.showInstructor &&
        ![
          "Checkride Flight",
          "Checkride Oral",
          "Ground Training",
          "Interview Oral",
          "Potential Student",
        ].includes(this.event?.eventType?.name)
      );
    },
  },
  methods: {
    getCardSwipes() {
      if (this.event.customer1) {
        let params = {
          userId: this.event.customer1.userId,
          startTime: this.event.startDateTime,
          endTime: new dayjs(),
        };
        return usersAPIService
          .getCardPunchesForUser(params, this.$router)
          .then((response) => {
            this.cardSwipes = response;
            this.checkStatusPairs();
          })
          .catch(() => {
            this.checkInError = true;
          });
      }
    },
    checkStatusPairs() {
      const statusCount = {
        LOGGED_IN: 0,
        LOGGED_OUT: 0,
      };
      let lastStatus;

      for (let punch of this.cardSwipes) {
        if (lastStatus === punch.status) {
          this.checkInError = true;
          return;
        } else if (punch.status in statusCount) {
          statusCount[punch.status]++;
          lastStatus = punch.status;
        }
      }

      this.checkInError = statusCount.LOGGED_IN !== statusCount.LOGGED_OUT;
      if (!this.checkInError) {
        this.calculateFlightTime();
      }
    },
    calculateFlightTime() {
      let flightTime = 0;
      let previousPunch = null;

      for (let punch of this.cardSwipes) {
        if (punch.status === "LOGGED_IN") {
          previousPunch = punch;
        } else if (previousPunch) {
          flightTime += dayjs(punch.entryTime).diff(
            dayjs(previousPunch.entryTime),
            "hour",
            true,
          );
        }
      }
      this.hobbsIn = (
        Math.ceil((parseFloat(this.hobbsOut) + flightTime) * 10) / 10
      ).toFixed(1);
      this.calculateFlightInstructionHours();
    },

    setAndFormatData() {
      this.eventStart = dayjs(this.event.startDateTime).format(
        "MM/DD/YY, hh:mm A",
      );
      this.eventEnd = dayjs(this.event.endDateTime).format("MM/DD/YY, hh:mm A");
      this.hobbsOut = this.event.aircraft?.hobbs;
      this.tachOut = this.event.aircraft?.tach;
      if (this.event.instructor) {
        const instructor = this.event.instructor.user;
        this.instructorName = `${instructor.firstName} ${instructor.lastName}`;
        this.instructorPhone = formatPhoneNumber(instructor.phone);
      }
    },
    calculateFlightInstructionHours() {
      const hobbsIn = parseFloat(this.hobbsIn);
      const hobbsOut = parseFloat(this.hobbsOut);

      if (!isNaN(hobbsIn) && !isNaN(hobbsOut)) {
        this.flightInstructionHours = (hobbsIn - hobbsOut).toFixed(1);
      }
    },
    async handleSubmit() {
      if (this.validateForm()) {
        const updatedEvent = {
          ...this.event,
          checkInInfo: {
            hobbs: parseFloat(this.hobbsIn),
            tach: parseFloat(this.tachIn),
            flightInstructionHours: parseFloat(this.flightInstructionHours),
            groundInstructionHours: parseFloat(this.groundInstructionHours),
          },
        };
        this.$emit("check-in-complete", updatedEvent);
      }
    },
    validateForm() {
      // const requiredFields = [];
      //
      // if (this.showHobbs) {
      //   requiredFields.push("Hobbs Time Out", "Hobbs Time In");
      //   if (this.showTach) {
      //     requiredFields.push("Tach Time Out", "");
      //   }
      // }
      //
      // if (this.showInstructor) {
      //   requiredFields.push("groundInstructionHours");
      //   if (this.showFlightInstructionHours) {
      //     requiredFields.push("flightInstructionHours");
      //   }
      // }
      //
      // const missingFields = requiredFields.filter((field) => !this[field]);
      // if (missingFields.length) {
      //   alert(`The following fields are required: ${missingFields.join(", ")}`);
      //   return false;
      // }
      return true;
    },
    closeModal() {
      this.$emit("close");
    },
  },
});
</script>
<style module scoped>
.reservationPopup {
  position: absolute;
  top: 0;
  left: 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  width: 700px;
  height: 822px;
  overflow: hidden;
}
.reservation {
  position: absolute;
  top: 30px;
  left: 30px;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dualInstruction {
  position: absolute;
  top: 79px;
  left: 30px;
  font-size: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.start0327240730 {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.start0327240730Parent {
  position: absolute;
  top: 145px;
  left: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.inputStyle {
  flex-grow: 1;
  height: 30px;
  border: none;
  background-color: transparent;
  font-size: 18px;
  color: black;
  padding: 0;
  border-radius: 5px;
  outline: none;
}
.inputStyle::placeholder {
  color: #9b9b9b;
}
.aircraft {
  position: relative;
}
.n2361r {
  position: relative;
  font-size: 22px;
}
.aircraftParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.instructorParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0;
}
.hobbsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.hobbsTimeOut {
  width: 200px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.wrapper {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  box-sizing: border-box;
  color: rgba(64, 64, 64, 0.75);
}
.hobbsTimeOutParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
/*
.addSquawk {
  position: relative;
  color: rgba(64, 64, 64, 0.75);
}
.frameItem {
  position: absolute;
  top: calc(50% - 13px);
  right: 2px;
  border-radius: 100px;
  background-color: #fff;
  width: 26px;
  height: 26px;
}
.switchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
.selectionContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
*/
.instructorWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.continueWrapper {
  align-self: stretch;
  border: none;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  z-index: 2;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.frameParent {
  margin-top: 150px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
  height: 100%;
  padding-right: 10px;
  overflow-y: auto;
}
.vectorIcon {
  position: absolute;
  top: 39px;
  right: 51px;
  width: 12px;
  height: 12px;
  cursor: pointer;
}
.reservationParent {
  width: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin: auto;
  max-height: 90vh;
  height: 90vh;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
.checkInError {
  text-align: center;
  color: #dc2427;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 3px;
}
</style>
